/*
 * File: ProductsNotFound.tsx
 * Project: meki
 * File Created: Thursday, 12th August 2021 9:45:49 am
 * Author: Luis Aparicio (luis@inventures.cl)
 * -----
 * Last Modified: Thursday, 16th November 2023 3:39:12 pm
 * Modified By: Blanca Munizaga (blanca@inventures.cl)
 * -----
 * Copyright 2019 - 2021 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */
import React from 'react';
import { Button } from '@mui/material';
import Typography from '@mui/material/Typography';
import dynamic from 'next/dynamic';
import { styled } from '@mui/system';

const NotFound = dynamic(() => {
  const promise = import('@components/icons/NotFound').then(
    (mod) => mod.NotFound,
  );
  return promise;
});
const DivText = styled('div')({
  flexGrow: 1,
  paddingTop: 20,
  textAlign: 'center',
  justifyContent: 'center',
  alignItems: 'center',
  '@media (min-width: 1024px)': {
    paddingTop: '10%',
  },
});
const MiddleTextTypography = styled(Typography)({ padding: '10px 0' });

interface ProductsNotFound {
  onClick?: () => void;
}

export function ProductsNotFound(params: ProductsNotFound) {
  const { onClick } = params;

  return (
    <DivText>
      <Typography variant="h6" color="textPrimary">
        No encontramos lo que buscas
      </Typography>
      <MiddleTextTypography variant="body2" color="textPrimary">
        Intenta con otro filtro o limpiandolos
      </MiddleTextTypography>
      <Button
        color="primary"
        variant="contained"
        size="large"
        onClick={onClick}
      >
        LIMPIAR FILTROS
      </Button>
      <div>
        <NotFound />
      </div>
    </DivText>
  );
}
